import { render } from "./CompanyMenuItem.vue?vue&type=template&id=5f2e431f&ts=true"
import script from "./CompanyMenuItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompanyMenuItem.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Navigation/CompanyMenuItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f2e431f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f2e431f', __exports__)) {
    console.log('reload')
    api.reload('5f2e431f', __exports__)
  }
  
  module.hot.accept("./CompanyMenuItem.vue?vue&type=template&id=5f2e431f&ts=true", () => {
    console.log('re-render')
    api.rerender('5f2e431f', render)
  })

}


export default __exports__